export default {
  SET_VIEW_HEIGHT: 'SET_VIEW_HEIGHT',
  CHECK_MESSAGE_VISIBLE: 'CHECK_MESSAGE_VISIBLE',
  SET_MESSAGE_VISIBLE: 'SET_MESSAGE_VISIBLE',
  SET_LOADING_STATE: 'SET_LOADING_STATE',
};
